<template>
<div class="f14 input" :class="{'error': error}" :data-value="error">
  <slot name="before"></slot>
  <input 
    :placeholder="placeholder" 
    :value="value"
    v-on="inputListeners"
    :type="type"
    :maxlength = "max"
    :minlength = "min"
    />
  <slot name="after"></slot>
  <label></label>
</div>
</template>
<script>
export default {
  name: 'baseinput',
  props: {
    min: Number,
    max: Number,
    type:String,
    error: String,
    value: [String, Number],
    placeholder: {
      type: String,
      default: '请输入相关内容'
    }
  },
  components: {
  },
  computed: {
    inputListeners () {
      var vm = this
      return Object.assign({},
        this.$listeners,
        {
          // 这里确保组件配合 `v-model` 的工作
          input: function (event) {
            vm.$emit('input', event.target.value)
          }
        }
      )
    }
  },
  methods: {
  },
  mounted () {
  }
}
</script>
